import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileArrowLeftIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFileArrowLeftIn"><Path d="M14.5 21.5H19.5V9L13 2.5H4.5V14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13 3V9H19" stroke="currentColor" strokeLinecap="round"/><Path d="M3.5 19.5H10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 16.5L11.5 19.5L8.5 22.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFileArrowLeftIn;
